import { render, staticRenderFns } from "./loginDialog.vue?vue&type=template&id=2144988c"
import script from "./loginDialog.vue?vue&type=script&lang=js"
export * from "./loginDialog.vue?vue&type=script&lang=js"
import style0 from "./loginDialog.vue?vue&type=style&index=0&id=2144988c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports